import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { Tooltip } from "../../../../../revvComponents";

// Internal Imports
import { IMAGE_URLS } from "../../../../../constants";

const { TableAddRowBelow, TableAddRowAbove, TableRemoveRow } = IMAGE_URLS;

class RowOptionBtns extends Component {
  state = {};

  _showRowOptions = () => {
    const {
      component: { data: tableData },
    } = this.props;
    const { readOnly, focusRowID } = this.props;
    const {
      data,
      attributes: { dataSource },
    } = tableData;
    const showAddRow = true;
    const showRemoveRow =
      dataSource === "TableApi" && focusRowID === 0
        ? false
        : Array.isArray(data) && data.length > 1;
    return (showAddRow || showRemoveRow) && !readOnly ? (
      <div className="row-options rowoptionsbtns-wrapper">
        {showAddRow && (
          <div
            className={`table-add-column-items ${
              this.props.selectedRowId !== null &&
              this.props.selectedColumnId === null
                ? "disabled-options"
                : ""
            }`}>
            {/* Row Options */}
            <Tooltip
              placement="bottom"
              overlay="Add Row Above"
              align={{
                offset: [0, 3],
              }}>
              <span
                data-test="table-add-row-above-button-span"
                className="revvtabletoolbar-btn btn-positive"
                onMouseDown={e => this.props.addRow("U", e)}
                // onKeyDown={() => {}}
                role="button"
                tabIndex={0}>
                <img className="" src={TableAddRowAbove} alt="Add Column" />
              </span>
            </Tooltip>
            <Tooltip
              placement="bottom"
              overlay="Add Row Below"
              align={{
                offset: [0, 3],
              }}>
              <span
                data-test="table-add-row-below-button-span"
                className="revvtabletoolbar-btn btn-positive"
                onMouseDown={e => this.props.addRow("D", e)}
                // onKeyDown={() => {}}
                role="button"
                tabIndex={0}>
                <img className="" src={TableAddRowBelow} alt="Add Column" />
              </span>
            </Tooltip>
          </div>
        )}
        {showRemoveRow && (
          <Tooltip
            placement="bottom"
            overlay="Remove Row"
            align={{
              offset: [0, 3],
            }}>
            <span
              data-test="table-remove-row-button-span"
              className="revvtabletoolbar-btn btn-negative"
              onMouseDown={this.props.removeRow}
              // onKeyDown={this._removeRow}
              role="button"
              tabIndex={0}>
              <img className="" src={TableRemoveRow} alt="Add Column" />
            </span>
          </Tooltip>
        )}
      </div>
    ) : null;
  };

  render() {
    return <Fragment>{this._showRowOptions()}</Fragment>;
  }
}

const mapStateToProps = state => {
  const { activeComponentMeta } = state.DocumentStore;
  let focusRowID = null;
  let focusColumnID = null;

  const { tableRowId, tableColId } = activeComponentMeta;

  focusRowID = tableRowId !== undefined ? tableRowId : null;
  focusColumnID = tableColId !== undefined ? tableColId : null;
  const activeCell =
    focusRowID !== undefined && focusColumnID !== undefined
      ? [focusRowID, focusColumnID]
      : null;

  return {
    focusRowID,
    focusColumnID,
    activeCell,
    activeComponentMeta,
  };
};

export default connect(mapStateToProps, null)(RowOptionBtns);
